<template>
    <el-dialog :title="$t('masters.createCountry')" :visible.sync="showDialog" @close="closeDialog" width="40%" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" size="small" label-width="140px" label-position="left">
            <el-form-item label="ISO Code" prop="ISOCode">
                <el-input v-model="form.ISOCode"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.name')" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
        </el-form>
        <span>
            <el-button type="primary" @click="save" v-if="$isFullAdmin">{{$t('common.create')}}</el-button>
            <el-button @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { EventBus } from "@/app/event-bus.js";
    import api from "../api";
    export default {
        name: "create-country-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: {
                    name: null,
                    ISOCode: null
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCounryName'),
                            trigger: "blur",
                        }],
                    ISOCode: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCounryISOCode'),
                            trigger: "blur",
                            max: 2
                        }],
                },
                showDialog: this.visible
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            }
        },
        methods: {
            closeDialog() {
                this.showDialog = false;
                this.$refs["form"].resetFields();
                this.$emit("dialogClosed");
            },
            save() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        api
                            .saveCountry(this.form)
                            .then(response => {
                                if (response != null && response.data != null) {
                                    EventBus.$emit("countryCreated");
                                    this.$message({
                                        type: "success",
                                        message: this.$t('common.countryCreated')
                                    });
                                }
                                this.closeDialog();
                            });
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/customers/components/CreateCountryDialog.vue